export class CustomDataAppendDataModel {
  appendData = false;

  constructor(appendData?: boolean) {
    this.appendData = appendData === true ? true : false;
  }

  setUrlArgs(uri: string): string {
    if (
      this.appendData === false
    ) {
      return uri;
    }

    const args = [];
    if (this.appendData === true) {
      args.push('appenddata=1');
    }

    return uri + (uri.indexOf('?') > -1 ? '&' : '?') + args.join('&');
  }
}
